import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import DynamicGalleryModal from './DynamicGalleryModal';

const DynamicPhotoGallery = ({ gallery = [] }) => {
  const hasImages = gallery && gallery.length > 0;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleImageClick = (index) => {
    setSelectedIndex(index);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handlePrevious = () => {
    setSelectedIndex((prev) => prev - 1);
  };

  const handleNext = () => {
    setSelectedIndex((prev) => prev + 1);
  };

  if (!hasImages) return null;

  return (
    <Box
      id="photoGallerySection"
      sx={{
        maxWidth: '1900px',
        margin: { xs: '0 16px', sm: '0 24px', lg: '0 32px' },
        pb: 6
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 4
        }}>
        <Box sx={{ flex: 1, height: '2px', backgroundColor: '#000', mx: 2 }} />
        <Typography
          sx={{
            fontSize: { xs: '14px', sm: '18px', md: '22px' },
            fontFamily: 'gothamBold',
            textAlign: 'center',
            color: '#27306B',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap'
          }}>
          Photo Gallery
        </Typography>
        <Box sx={{ flex: 1, height: '2px', backgroundColor: '#000', mx: 2 }} />
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(1, minmax(0, 1fr))',
            sm: 'repeat(2, minmax(0, 1fr))',
            md: 'repeat(3, minmax(0, 1fr))'
          },
          gap: 2
        }}>
        {gallery.map((image, index) => (
          <Box
            key={`${image}-${index}`}
            onClick={() => handleImageClick(index)}
            sx={{
              overflow: 'hidden',
              borderRadius: '10px',
              aspectRatio: '16/10',
              cursor: 'pointer',
              '&:hover img': {
                transform: 'scale(1.05)',
                transition: 'transform 0.3s ease'
              }
            }}>
            <img
              loading="lazy"
              src={image}
              alt={`Photo gallery ${index + 1}`}
              style={{
                width: '100%',
                height: '100%',
                display: 'block',
                objectFit: 'cover',
                transition: 'transform 0.3s ease'
              }}
            />
          </Box>
        ))}
      </Box>

      <DynamicGalleryModal
        gallery={gallery}
        selectedIndex={selectedIndex}
        open={isModalOpen}
        onClose={handleClose}
        onPrevious={handlePrevious}
        onNext={handleNext}
      />
    </Box>
  );
};

export default DynamicPhotoGallery;
